export const SET_CONTRACT = 'SET_CONTRACT';
export const SET_CLIENT = 'SET_CLIENT';
